/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Artifact_Forked_FromInputs */



/**
* | output |
* | --- |
* | "forked from {name}" |
*
* @param {Artifact_Forked_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_forked_from = /** @type {((inputs: Artifact_Forked_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Forked_FromInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`abgeleitet von ${i?.name}`)
	return /** @type {LocalizedString} */ (`forked from ${i?.name}`)
});